import { Link, useLocation } from "react-router";
import Logo from "../../assets/texpress.png";
import { cn } from "@/lib/utils";
import {
  Card,
  CardContent,

} from "@/components/ui/card";

import { Check,  X } from "lucide-react";

const JoinSuccessErrorMessage = () => {
  const location =  useLocation()
  return (
    <div className="flex flex-col  items-center justify-center gap-6 min-h-svh bg-muted ">
      <div className="flex flex-col gap-6">
        <Link to="/" className="flex items-center justify-center h-10">
          <img src={Logo} className="h-10" />
        </Link>

        <div className={cn("flex flex-col gap-6")}>
          <Card className="w-full lg:w-[542px] p-12 rounded-[12px]">
            <CardContent>
              <div className="flex flex-col justify-center items-center gap-8">
                <div className={cn("w-[64px] h-[64px] rounded-full flex items-center justify-center", !location?.state?.status?"bg-error-0":"bg-green-0")}>
             {!location?.state?.status? 
            <X className="text-error"/> :
                  <Check className="text-green"/>
            }
              
                </div>
<div className="grid gap-3">

                <h5 className="text-center text-primary-3 text-2xl font-medium">{!location?.state?.status? location?.state?.error:"Successfully Joined Team"}</h5>
                {!location?.state?.status?
                <p className="text-center text-[#565C6B] text-sm">
Sorry, it seems your invite to join the team has expired, kindly reach out to the admin to resend the invite
                </p>
                :
                <p className="text-center text-[#565C6B] text-sm">
                
                  Congratulations, you have been added to Team, Kindly go to <Link to='/dashboard' className="text-primary text-sm">dashboard</Link> page to proceed.
                
                </p>}
</div>
              </div>

              
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default JoinSuccessErrorMessage;
